import axios from "axios";
import { config } from "../config";

export const submitUnsubscribeRequest = async (data: { reason: string }) => {
  const response = await axios.post(
    `${config.VANTAGE_API_URL}/api/Unsubscribe/SubmitUnsubscribeRequest`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};